import React from 'react';
import styled from 'styled-components';
import MotifTooltip from '@ey/motif-react-wrapper/Tooltip';

export default function Tooltip(props) {
	const {
		id,
		variant,
		trigger,
		placement,
		className,
		title,
		flip,
		hide,
		allowClick,
		allowHover,
		closeButtonProps,
		forceHideCounter,
		hideCloseButton,
		hideArrow,
		icons,
		usePortal,
		children
	} = props;
	return (
		<StyledMotifTooltip
			id={id}
			contentClassName={className}
			title={title}
			flip={flip}
			variant={variant ? variant : 'alt'}
			trigger={trigger}
			placement={placement}
			closeButtonProps={closeButtonProps}
			forceHideCounter={forceHideCounter}
			allowClick={allowClick}
			allowHover={allowHover}
			hide={hide}
			hideCloseButton={hideCloseButton}
			hideArrow={hideArrow}
			icons={icons}
			usePortal={usePortal}
		>
			{children}
		</StyledMotifTooltip>
	);
}

const StyledMotifTooltip = styled(MotifTooltip)``;
